import React from 'react';

const ShowHighlights = () => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black border-2 border-gold rounded-3xl mb-8">
      <div className="container mx-auto max-w-5xl">
        <h2 className="text-xl sm:text-[3.2vw] md:text-[3vw] lg:text-[2.85vw] text-center mb-16 text-gold font-semibold sm:whitespace-nowrap" style={{ textTransform: 'none', fontFamily: 'Montserrat, sans-serif' }}>
          Show Highlights
        </h2>
        
        <div className="grid md:grid-cols-3 gap-6">
          {/* Classic Hits Card */}
          <div className="bg-black/50 backdrop-blur-sm p-6 rounded-xl border-2 border-gold/30 hover:border-gold transition-all duration-300 text-center">
            <h3 className="text-xl text-gold mb-4 font-semibold" style={{ fontFamily: 'Montserrat, sans-serif' }}>Classic Hits</h3>
            <ul className="space-y-2 text-white/90">
              <li>Jailhouse Rock</li>
              <li>Blue Suede Shoes</li>
              <li>Devil In Disguise</li>
              <li>Viva Las Vegas</li>
            </ul>
          </div>
          
          {/* Vegas Era Card */}
          <div className="bg-black/50 backdrop-blur-sm p-6 rounded-xl border-2 border-cyan/30 hover:border-cyan transition-all duration-300 text-center">
            <h3 className="text-xl text-cyan mb-4 font-semibold" style={{ fontFamily: 'Montserrat, sans-serif' }}>Vegas Era</h3>
            <ul className="space-y-2 text-white/90">
              <li>Suspicious Minds</li>
              <li>American Trilogy</li>
              <li>Burning Love</li>
              <li>Way Down</li>
            </ul>
          </div>
          
          {/* Gospel & Ballads Card */}
          <div className="bg-black/50 backdrop-blur-sm p-6 rounded-xl border-2 border-red/30 hover:border-red transition-all duration-300 text-center">
            <h3 className="text-xl text-red mb-4 font-semibold" style={{ fontFamily: 'Montserrat, sans-serif' }}>Gospel and Ballads</h3>
            <ul className="space-y-2 text-white/90">
              <li>You Gave Me A Mountain</li>
              <li>Love Me Tender</li>
              <li>Always On My Mind</li>
              <li>I Just Can't Help Believing</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ShowHighlights;
